import KForm from 'app/components/Modules/Form/KForm'
import KFormInfo from 'app/components/Modules/Form/KFormInfo'
import KRadio from 'app/components/Modules/Form/KRadio'
import KTextArea from 'app/components/Modules/Form/KTextArea'
import { KFormProps, RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'

import { MemberProps } from '../convention'

const Form: React.FC<MemberProps<IQuoteFeedback, KFormProps<IQuoteFeedback>>> = ({
  member,
  props: { onSuccess } = {}
}) => {
  return (
    <KForm
      inlineErrors
      recordType={RecordType.quote_feedback}
      layout="vertical"
      initialValues={member}
      onSuccess={onSuccess}>
      <KFormInfo />
      <KRadio name="why" required />
      <KTextArea name="suggestions" allowClear={false} />
    </KForm>
  )
}

export default Form
